import React from 'react';
import { Col, Form } from 'antd';
import PhoneInput from 'react-phone-input-2';
import type { FormInstance } from 'antd';
import CustomInput from '@/components/CustomInput';
import type { ChannelType, AgentDrawerFormValues } from '../types';
import { isValidPhoneNumber } from 'libphonenumber-js';

export const ChannelSection: React.FC<{
  channelType: ChannelType;
  form: FormInstance<AgentDrawerFormValues>;
  disabled?: boolean;
}> = ({ channelType, form, disabled = false }) => {
  if (channelType === 'phone') {
    return (
      <Col span={24}>
        <Form.Item
          required={!disabled}
          label='Primary AI phone number'
          name='phone_number'
          className='agentFormNoMargin'
          rules={
            disabled
              ? []
              : [
                  {
                    validator: (_, value?: string) => {
                      const v = String(value || '').trim();

                      if (!v) {
                        return Promise.reject(
                          new Error('Primary AI phone number is required')
                        );
                      }

                      try {
                        if (!isValidPhoneNumber(v)) {
                          return Promise.reject(
                            new Error('Invalid phone number')
                          );
                        }
                      } catch {
                        return Promise.reject(
                          new Error('Invalid phone number')
                        );
                      }

                      const digits = v.replace(/[^\d]/g, '');
                      if (
                        (digits.startsWith('1') || v.startsWith('+1')) &&
                        digits.includes('555')
                      ) {
                        return Promise.reject(
                          new Error('Please enter a real phone number')
                        );
                      }

                      return Promise.resolve();
                    },
                  },
                ]
          }
        >
          <PhoneInput
            country='us'
            disabled={disabled}
            value={(form.getFieldValue('phone_number') as string) || ''}
            onChange={(value) => {
              if (disabled) return;

              const next = value ? `+${value}` : '';
              form.setFieldsValue({
                phone_number: next,
              } as Partial<AgentDrawerFormValues>);
            }}
            containerClass='agentPhone agentPhone--primary'
            inputClass='agentPhone__input agentPhone__input--primary'
            buttonClass='agentPhone__button agentPhone__button--primary'
            dropdownClass='agentPhone__dropdown'
          />
        </Form.Item>
      </Col>
    );
  }
  return (
    <Col span={24}>
      <Form.Item
        label='Email'
        className='custom-input form-input-style'
        name='email'
        required={!disabled}
        rules={
          disabled
            ? []
            : [
                { required: true, message: 'Email is required' },
                { type: 'email', message: 'Invalid email' },
              ]
        }
      >
        <CustomInput
          disabled={disabled}
          placeholder='customer@zoomlogi.com'
          height='36px'
          border='2px solid var(--gray-300)'
          width='100%'
          bgColor='var(--surface-container)'
          textColor='var(--text-secondary)'
          borderRadius='8px'
          placeholderColor='var(--text-secondary)'
        />
      </Form.Item>
    </Col>
  );
};
